/**
 * Sims
 * http://simsrecycling.com
 *
 * Copyright (c) 2017 10up
 * Licensed under the GPL-2.0+ license.
 */

( function( window, $ ) {
	'use strict';

	/**
	 * Object to represent a location list finder.
	 *
	 * @param {object} el The container element for the location finder.
	 *
	 * @returns {void}
	 */
	var LocationListFinder = function( el ) {
		this.$el = null;
		this.$countrySelectField = null;
		this.$resultsListEl = null;
		this.$feedbackEl = null;
		this.settings = null;
		this.loadingMessageTimeout = null;

		this.init( el );
	};

	LocationListFinder.prototype = {
		/**
		 * Initialize the uploader.
		 *
		 * @param {object} el The container element for the uploader.
		 *
		 * @returns {void}
		 */
		init: function( el ) {
			if ( !el ) {
				return;
			}

			this.$el = $( el );

			this.initSettings();
			this.initEvents();

			this.hideFeedbackMessage();
		},

		/**
		 * Initialize the settings.
		 *
		 * @returns {void}
		 */
		initSettings: function() {
			if ( locationFinderAPISettings ) {
				this.settings = locationFinderAPISettings;
			}
		},

		getSetting: function( setting ) {
			if ( this.settings && this.settings.hasOwnProperty( setting ) ) {
				return this.settings[setting];
			} else {
				return null;
			}
		},

		/**
		 * Initialize events for the finder.
		 *
		 * @returns {void}
		 */
		initEvents: function() {
			var $countrySelectField = this.getCountrySelectField();

			if ( $countrySelectField ) {
				$countrySelectField.on( 'change', $.proxy( this.didChangeCountrySelectField, this ) );
			}
		},

		/**
		 * Get the container element for the uploader.
		 *
		 * @returns {object} The element.
		 */
		getEl: function() {
			return this.$el;
		},

		/**
		 * Get the country select field.
		 *
		 * @returns {object} The element.
		 */
		getCountrySelectField: function() {
			var $el = this.getEl();

			if ( !$el ) {
				return;
			}

			this.$countrySelectField = $el.find( '.country-select' );

			return this.$countrySelectField;
		},

		/**
		 * Get the results list element.
		 *
		 * @returns {object} The element.
		 */
		getResultsListEl: function() {
			var $el = this.getEl();

			if ( !$el ) {
				return;
			}

			this.$resultsListEl = $el.find( '.location-list' );

			return this.$resultsListEl;
		},

		/**
		 * Get the feedback element.
		 *
		 * @returns {object} The element.
		 */
		getFeedbackEl: function() {
			var $el = this.getEl();

			if ( !$el ) {
				return;
			}

			this.$feedbackEl = $el.find( '.location-feedback' );

			return this.$feedbackEl;
		},

		/**
		 * Get the selected country.
		 *
		 * @returns {void}
		 */
		getSelectedCountry: function() {
			var $field = this.getCountrySelectField();

			if ( $field ) {
				return $field.val();
			}

			return '';
		},

		/**
		 * Get the template to use to format the results.
		 *
		 * @returns {string} The template name.
		 */
		getResultsTemplate: function() {
			var $el = this.getEl();

			if ( !$el ) {
				return;
			}

			return $el.attr( 'data-response-template' );
		},

		/**
		 * Handle user changing the country select field.
		 *
		 * @param {object} event The event object.
		 *
		 * @returns {void}
		 */
		didChangeCountrySelectField: function( event ) {
			this.getLocations();
			this.hideFeedbackMessage();
			this.showLoadingMessage();
		},

		/**
		 * Get locations via an AJAX request.
		 *
		 * @returns {void}
		 */
		getLocations: function() {
			var url = this.getSetting( 'listFinderAPIGetLocationsURL' ),
				data = {},
				self = this;

			data.country = this.getSelectedCountry();
			data.template = this.getResultsTemplate();
			data._wpnonce = this.getSetting( 'nonce' );

			$.ajax( {
				url: url,
				method: 'GET',
				data: data
			} ).done( function( response ) {
				self.handleGetLocationsResponse( response );
			} );
		},

		/**
		 * Handle the response returned when requesting locations.
		 *
		 * @param {object} response The response object.
		 *
		 * @returns {void}
		 */
		handleGetLocationsResponse: function( response ) {
			if ( !response ) {
				return;
			}

			if ( response.success && true === response.success ) {
				if ( response.data && response.data.html ) {
					var $resultsEl = this.getResultsListEl();

					if ( $resultsEl ) {
						$resultsEl.replaceWith( response.data.html );
						this.clearLoadingMessageTimeout();
						this.hideFeedbackMessage();
					}
				}
			} else if ( response.data && response.data.message ) {
				this.showFeedbackMessage( response.data.message );
			}
		},

		/**
		 * Display a loading message during AJAX requests.
		 *
		 * @param {string} message The message to display.
		 *
		 * @returns {void}
		 */
		showLoadingMessage: function( message ) {
			var self = this;

			// Show the loading message if results are not returned within a reasonable amount of time.
			this.loadingMessageTimeout = setTimeout( function() {
				var $el = self.getFeedbackEl();

				if ( !$el ) {
					return;
				}

				if ( !message ) {
					message = 'Loading...';
				}

				self.showFeedbackMessage( message );
			}, 500 );
		},

		/**
		 * Show a feedback message..
		 *
		 * @param {string} message The message to display.
		 *
		 * @returns {void}
		 */
		showFeedbackMessage: function( message ) {
			this.clearLoadingMessageTimeout();

			if ( !message ) {
				return;
			}

			var $el = this.getFeedbackEl();

			if ( $el ) {
				var $message = $( '<p></p>' ).text( message );

				$el.append( $message );
				$el.show();
			}
		},

		/**
		 * Hide all current feedback messages.
		 *
		 * @returns {void}
		 */
		hideFeedbackMessage: function() {
			this.clearLoadingMessageTimeout();

			var $el = this.getFeedbackEl();

			if ( $el ) {
				$el.hide();
				$el.empty();
			}
		},

		clearLoadingMessageTimeout: function() {
			clearTimeout( this.loadingMessageTimeout );
		}
	};

	$( document ).ready( function() {
		var locationListFinders = [];

		$( '.location-list-finder' ).each( function() {
			var finder = new LocationListFinder( this );

			locationListFinders.push( finder );
		} );
	} );

} )( window, jQuery );
